import {
  ConnectorModel,
  ELMA365ConnectorSettingsOutputTypeEnum,
  ConnectorAvailability,
  ConnectorStatus,
  ConnectorApiKeyAuthTypeEnum,
  ConnectorOAuth2AuthTypeEnum,
  ConnectorApiKeyAuth,
  ConnectorOAuth2Auth,
  Auth,
} from '../../../gamma-api';
import { PUBLIC_URL } from '../../utils/configUtil';

export const MAIN_CLASS_NAME = 'connector-modal';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const CHECK_BUTTONS_CLASS_NAME = `${CONTENT_CLASS_NAME}__check-buttons`;
export const CANCEL_CHECK_BUTTON_CLASS_NAME = `${CHECK_BUTTONS_CLASS_NAME}__cancel`;
export const OAUTH_DESCRIPTION_CLASS_NAME = `${CONTENT_CLASS_NAME}__oauth-description`;
export const CALLBACK_COPY_BUTTON_CLASS_NAME = `${OAUTH_DESCRIPTION_CLASS_NAME}__callback-copy-button`;
export const CALLBACK_URI_CLASS_NAME = `${OAUTH_DESCRIPTION_CLASS_NAME}__callback-uri`;

export const SHOW_CALLBACK_COPIED_TIMEOUT_MS = 2000;
export const OAUTH2_CALLBACK_URI = `${PUBLIC_URL}/api/pub/v1/security/sessions/callback`;
export const OAUTH_CHECK_INTERVAL = 1000;

export const EMPTY_API_KEY_SETTINGS: Auth & ConnectorApiKeyAuth = {
  type: ConnectorApiKeyAuthTypeEnum.ApiKey,
  token: '',
};

export const EMPTY_OAUTH_2_SETTINGS: Auth & ConnectorOAuth2Auth & { [key: string]: string } = {
  type: ConnectorOAuth2AuthTypeEnum.OAuth2,
  authority: '',
  authorize_endpoint: '',
  token_endpoint: '',
  client_id: '',
  client_secret: '',
  scope: '',
};

export const EMPTY_CONNECTOR: ConnectorModel = {
  connector_id: '',
  availability: ConnectorAvailability.Enabled,
  status: ConnectorStatus.Unknown,
  name: '',
  settings: {
    type: ELMA365ConnectorSettingsOutputTypeEnum.Elma365,
    apis: {
      web: {
        url: '',
        auth: EMPTY_API_KEY_SETTINGS,
      },
    },
  },
  problem: null,
};
